// src/App.jsx
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { FormProvider } from './context/FormContext';
import AppRoutes from './routes/AppRoutes';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import { Provider } from 'react-redux'; // Redux Provider'ı ekleyin
import store from './redux/store'; // Redux store'unuzu içe aktarın
import LanguageSwitcher from './components/LanguageSwitcher';
import SpreadsheetDemo from './pages/Spreadsheet/SpreadsheetDemo';

function App() {
  // URL'den spreadsheet demo'yu kontrol et
  const isSpreadsheetDemo = window.location.pathname === '/spreadsheet-demo';

  return (
    <Provider store={store}> {/* Redux Provider ile sarın */}
      <BrowserRouter basename="/">
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <FormProvider>
              <LanguageSwitcher />
              {isSpreadsheetDemo ? <SpreadsheetDemo /> : <AppRoutes />}
            </FormProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
    
  );
}

export default App;